import React from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';

const Navbar = ({ username, manager }) => {
  return (
    <div className="navbar">
      <div style={{ display: 'flex', gap: '30px' }}>
        <Link to="/Home">
          <i className="fas fa-home"></i>
        </Link>
        {manager && <Link to="/Admin">
          <i className="fas fa-lock"></i>
        </Link>}
      </div>
      <div>
        <span>שלום {username}</span>
      </div>

      <Link id="Logout" to="/Logout">
        <i className="fas fa-sign-out-alt"></i>
      </Link>
    </div>
  );
};

export default Navbar;
